import * as Sentry from "@sentry/react";

import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";

import App from "./App";
import { reportCspViolationsToSentry } from "./utils/reportCspViolationToSentry";

Sentry.init({
  dsn: process.env.NX_SENTRY_DSN,
  environment: process.env.NX_ENVIRONMENT,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/test-console\.lunalocate\.com/,
    /^https:\/\/rc-console\.lunalocate\.com/,
    /^https:\/\/console\.lunalocate\.com/
  ],
  enabled: process.env.NX_ENVIRONMENT !== "local",
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Forward browser CSP violations (report-only during rollout) to Sentry.
// See apps/luna-locate/csp.config.js for the policy allowlist.
reportCspViolationsToSentry();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
